/** Cloudflare Worker URL hosting the Durable Object agents */
export const AGENT_WORKER_HOST = import.meta.env.VITE_AGENT_WORKER_HOST
  ?? 'cf-agent-platform.ac0764307.workers.dev'

/** Auto-detect: use local proxy in dev, direct Worker URL in production */
export const isDev = import.meta.env.DEV

/** Agent name format: use kebab-case for URL routing compatibility */
export const AGENT_NAME_FORMAT = 'kebab-case'
